(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-scroll-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const experience = document.querySelector('[data-bk-scroll-experience]');
    const main = document.querySelector('#MainContent[data-template="index"]');
    if (!experience || !main) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const shopButton = experience.querySelector('[data-bk-floating-shop]');
    const chapterNavigation = experience.querySelector('[data-bk-scroll-chapters]');
    const chapterLinks = chapterNavigation ? Array.from(chapterNavigation.querySelectorAll('[data-bk-chapter]')) : [];
    const pricing = document.getElementById('pricing');
    const footer = document.querySelector('footer');
    const itemSelector = '.bk-card, .bk-family-card, .bk-home-blog__article, .bk-acc details, .bk-table tbody tr, .bk-families__header, .bk-home-blog__header, .bk-brand-seo__inner, .bk-capture';

    const sections = Array.from(main.querySelectorAll(':scope > .shopify-section')).filter((section) => {
      return !section.querySelector('.bk-product-banner, .bk-shop-hero, .bk-scroll-experience');
    });

    // v8.2: mobile remains exactly on the fast path introduced in v8.
    if (window.matchMedia('(max-width: 749px)').matches) {
      sections.forEach((section) => section.classList.add('is-visible'));
      return;
    }

    // Desktop: reveal sections with IntersectionObserver only. No scroll-time geometry loop.
    if (!reduceMotion && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('bk-scroll-motion');
      sections.forEach((section) => {
        section.classList.add('bk-scroll-reveal');
        section.querySelectorAll(itemSelector).forEach((item, index) => {
          item.dataset.bkRevealItem = '';
          item.style.setProperty('--bk-reveal-delay', `${Math.min(index, 6) * 70}ms`);
        });
      });

      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .05 });
      sections.forEach((section) => revealObserver.observe(section));
    } else {
      sections.forEach((section) => section.classList.add('is-visible'));
    }

    if ('IntersectionObserver' in window && pricing && shopButton) {
      let passedPricing = false;
      let footerNear = false;
      const syncFloatingUI = () => {
        const visible = passedPricing && !footerNear;
        shopButton.classList.toggle('is-visible', visible);
        if (chapterNavigation) chapterNavigation.classList.toggle('is-visible', visible);
      };

      const pricingSentinel = new IntersectionObserver((entries) => {
        const entry = entries[0];
        passedPricing = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        syncFloatingUI();
      }, { threshold: 0 });
      pricingSentinel.observe(pricing);

      if (footer) {
        const footerObserver = new IntersectionObserver((entries) => {
          footerNear = entries[0].isIntersecting;
          syncFloatingUI();
        }, { rootMargin: '0px 0px 80px 0px', threshold: 0 });
        footerObserver.observe(footer);
      }
    }

    if ('IntersectionObserver' in window && chapterLinks.length) {
      const targets = chapterLinks.map((link) => document.getElementById(link.dataset.bkChapter)).filter(Boolean);
      const activeMap = new Map();
      const chapterObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => activeMap.set(entry.target.id, entry.isIntersecting ? entry.intersectionRatio : 0));
        let best = null;
        let bestRatio = 0;
        targets.forEach((target) => {
          const ratio = activeMap.get(target.id) || 0;
          if (ratio > bestRatio) { best = target.id; bestRatio = ratio; }
        });
        if (!best) return;
        chapterLinks.forEach((link) => link.classList.toggle('is-active', link.dataset.bkChapter === best));
      }, { rootMargin: '-18% 0px -55% 0px', threshold: [0, .1, .25, .5] });
      targets.forEach((target) => chapterObserver.observe(target));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
